import { cloneDeep } from 'lodash';

class BasketPopupController {

  constructor(basketPopupService, basket, guestnameService) {
    this.basketPopupService = basketPopupService;
    this.basket = basket;
    this.nameService = guestnameService;
    this.item = null;
  }

  reveal () {
    if (this.basketPopupService.show) {
      this.item = this.basketPopupService.item;
      if (!this.guests) {
        this.guests = cloneDeep(this.basketPopupService.guests);
      }

      return true;
    }

    this.item = null;
    this.guests = null;
    this.expiresAt = null;

    return false;
  }

  formatName (guest) {
    return this.item && this.nameService.format(guest);
  }

  reducedPrice () {
    return this.item && this.item.item_summary.price.price !== this.item.item_summary.price.original_price;
  }

  subtotal () {
    return this.item && this.item.item_summary.price.price * this.guests.length;
  }
}

BasketPopupController.$inject = [ 'basketPopupService', 'basket', 'guestnameService' ];

export default BasketPopupController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/popup/controllers/basket.popup.controller.js